var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('edit',{attrs:{"api":"coupons","title":"coupon","id":_vm.id,"fs":_vm.couponFields,"back":"/admin/coupons"},on:{"saved":_vm.saved}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }